module.exports = __webpack_public_path__ + "img/naveen-pro.ba7d6156.jpg";